import { Box, Flex, Text } from "@chakra-ui/react";
import { HelpCircle } from "lucide-react";
import { Tooltip } from "@/components/ui/tooltip";
import { palette } from "./theme";

export const Panel = ({
  title,
  subtitle,
  help,
  children,
}: React.PropsWithChildren<{
  title: string;
  subtitle?: string;
  /** Shown behind a help icon next to the title. For jargon the merchant
   * cannot be expected to know, such as the priority signal names. */
  help?: React.ReactNode;
}>): JSX.Element => (
  <Box
    bg={palette.surface}
    border="none"
    borderRadius="8px"
    p={5}
    boxShadow={palette.shadow}
    minW={0}
    h="100%"
    display="flex"
    flexDirection="column"
  >
    <Flex align="center" gap={2}>
      <Text fontSize="1.1rem" color={palette.text} fontWeight="600">
        {title}
      </Text>
      {help && (
        <Tooltip content={help} contentProps={{ maxW: "320px" }} showArrow>
          <Box as="span" color={palette.muted} cursor="help" lineHeight="0">
            <HelpCircle size={15} />
          </Box>
        </Tooltip>
      )}
    </Flex>
    {subtitle && (
      <Text
        color={palette.muted}
        fontSize="0.85rem"
        mt={1}
        mb={4}
        fontWeight="500"
      >
        {subtitle}
      </Text>
    )}
    {children}
  </Box>
);
